<dx-accordion [collapsible]="true"
              [selectedItem]="undefined"
              (onSelectionChanged)="onSelectionChanged($event)">
  <dxi-item [title]="'Attachments' | translate">
    <div *dxTemplate>
      <ng-container *ngFor="let attachedFile of attachedFiles; let i = index;">
        <div class="files-container">
          <div class="column">
            <div *ngIf="i === 0" class="header" translate>File Name</div>
            <div class="value">{{ attachedFile.fileName }}</div>
          </div>
          <div class="column">
            <div *ngIf="i === 0" class="header" translate>File Type</div>
            <div class="value">{{ attachedFile.fileType }}</div>
          </div>
          <div class="column">
            <div *ngIf="i === 0" class="header" translate>Size [kByte]</div>
            <div class="value">{{ attachedFile.fileSize }}</div>
          </div>
          <div class="column">
            <div *ngIf="i === 0" class="header empty"></div>
            <div class="download-file" (click)="downloadFile(attachedFile)">
              <object data="../../assets/images/download-file.svg" [width]="20" [height]="20"></object>
            </div>
          </div>
        </div>
      </ng-container>
      <dx-button id="btnUpload" text="{{'Upload file' | translate}}" type="success" (click)="uploadFile()"></dx-button>
    </div>
  </dxi-item>
</dx-accordion>
<input #uploadInput
       style="display: none"
       type="file"
       name="files[]"
       [accept]="uploadFileTypes"
       (change)="onUploadFileChange($event)" />
